import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-vertreter-list-view',
  imports: [],
  templateUrl: './vertreter.list-view.html',
  styleUrls: ['./vertreter.list-view.css'],
})
export class VertreterListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
